import {
  EntitySwitch,
  isKind,
} from '@backstage/plugin-catalog';

import { componentPage } from './EntityPage/ComponentPage';
import { apiPage } from './EntityPage/ApiPage';
import { groupPage } from './EntityPage/GroupPage';
import { userPage } from './EntityPage/UserPage';
import { systemPage } from './EntityPage/SystemPage';
import { domainPage } from './EntityPage/DomainPage';
import { unclaimedPage } from './EntityPage/UnclaimedPage';
import { defaultEntityPage } from './EntityPage/DefaultEntityPage';

export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('component')} children={componentPage} />
    <EntitySwitch.Case if={isKind('api')} children={apiPage} />
    <EntitySwitch.Case if={isKind('group')} children={groupPage} />
    <EntitySwitch.Case if={isKind('user')} children={userPage} />
    <EntitySwitch.Case if={isKind('system')} children={systemPage} />
    <EntitySwitch.Case if={isKind('domain')} children={domainPage} />
    <EntitySwitch.Case if={isKind('unclaimed')} children={unclaimedPage} />
    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
